import React, { useState, useEffect } from "react";
import { DatePicker, Input } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

const CustomDatePicker = ({
    value,
    onChange,
    disabledDate,
    t = (text) => text, // i18n fallback
}) => {
    const [inputValue, setInputValue] = useState("");
    const [calendarOpen, setCalendarOpen] = useState(false);

    useEffect(() => {
        if (value && dayjs(value).isValid()) {
            setInputValue(dayjs(value).format("DD-MM-YYYY"));
        } else {
            setInputValue("");
        }
    }, [value]);

    const formatInput = (val) => {
        const digits = val.replace(/\D/g, "");
        if (digits.length <= 2) return digits;
        if (digits.length <= 4) return `${digits.slice(0, 2)}-${digits.slice(2)}`;
        return `${digits.slice(0, 2)}-${digits.slice(2, 4)}-${digits.slice(4, 8)}`;
    };

    const handleInputChange = (e) => {
        const raw = e.target.value;
        const formatted = formatInput(raw);
        setInputValue(formatted);

        if (formatted.length === 10) {
            const parsed = dayjs(formatted, "DD-MM-YYYY", true);
            if (parsed.isValid()) {
                onChange(parsed);
            }
        }
    };

    const handleDatePickerChange = (date) => {
        if (date) {
            setInputValue(dayjs(date).format("DD-MM-YYYY"));
        } else {
            setInputValue("");
        }
        onChange(date);
        setCalendarOpen(false);
    };

    const handleInputFocus = () => {
        setCalendarOpen(true); // 👈 open calendar when input is focused
    };

    const handleInputBlur = () => {
        // ✅ If typed value is incomplete or invalid, reset to prop `value`
        const parsed = dayjs(inputValue, "DD-MM-YYYY", true);
        if (!parsed.isValid()) {
            if (value && dayjs(value).isValid()) {
                setInputValue(dayjs(value).format("DD-MM-YYYY"));
            } else {
                setInputValue("");
            }
        }
    };

    return (
        <div className="custom-datepicker-wrapper">
            <Input
                value={inputValue}
                onChange={handleInputChange}
                onFocus={handleInputFocus}
                onBlur={handleInputBlur}
                placeholder={t("DD_MM_YYYY")}
                className="ant-input"
                style={{
                    position: 'absolute',
                    width: '100%',
                    opacity: 1,
                    // background: 'red',
                    zIndex: 1,
                }}
            />
            <DatePicker
                style={{ width: '100%' }}
                value={value ? dayjs(value) : null}
                format="DD-MM-YYYY"
                onChange={handleDatePickerChange}
                disabledDate={disabledDate}
                open={calendarOpen}
                onOpenChange={setCalendarOpen}
                showToday={false}
                allowClear={false}
                inputReadOnly
            />
        </div>
    );
};

export default CustomDatePicker;
